class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search-results');
        this.clearButton = this.querySelector('.predictive-search__clear');
        this.submitButton = this.querySelector('.predictive-search__submit');
        this.form = this.querySelector('form');

        this.setupEventListeners();
    }

    setupEventListeners() {
        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        this.input.addEventListener('focus', this.onFocus.bind(this));

        this.submitButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.input.focus();
            if (this.input.value) {
                this.onChange();
            }
        });

        this.form.addEventListener('submit', this.onFormSubmit.bind(this));

        if (this.clearButton) {
            this.clearButton.addEventListener('click', this.onClear.bind(this));
        }

        // Close on click outside
        document.addEventListener('click', (event) => {
            if (!this.contains(event.target)) {
                this.close();
            }
        });
    }

    getQuery() {
        return this.input.value.trim();
    }

    onChange() {
        const searchTerm = this.getQuery();

        if (!searchTerm.length) {
            this.close();
            if (this.clearButton) this.clearButton.style.display = 'none';
            return;
        }

        if (this.clearButton) this.clearButton.style.display = 'flex';

        this.getSearchResults(searchTerm);
    }

    onFocus() {
        const searchTerm = this.getQuery();

        if (!searchTerm.length) return;

        if (this.getAttribute('results') === 'true') {
            this.open();
        } else {
            this.getSearchResults(searchTerm);
        }
    }

    onClear() {
        this.input.value = '';
        this.close();
        if (this.clearButton) this.clearButton.style.display = 'none';
        this.input.focus();
    }

    onFormSubmit(event) {
        if (!this.getQuery().length) {
            event.preventDefault();
        }
    }

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();

        this.setAttribute('loading', 'true');
        this.setAttribute('open', 'true');

        fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.setAttribute('results', 'true');
                this.removeAttribute('loading');
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.setAttribute('open', 'true');
        this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', 'false');
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);
